export const personalInfo = {
  name: "Ahamed Sagar",
  title: "Creative Designer & Photographer",
  taglines: [
    "Graphic Designer.",
    "Photographer.",
    "Social Media Manager.",
    "Content Creator.",
    "Visual Storyteller.",
  ],
  bio: [
    "Hi, I'm Ahamed Sagar — a passionate graphic designer, photographer, and social media manager dedicated to creating designs and visuals that inspire and connect.",
    "I believe every brand has a unique story worth telling. Through creative photography, compelling graphics, and strategic content, I help brands stand out and build meaningful connections with their audience.",
    "From fashion brands to tech companies, I've helped businesses grow their online presence, create viral content, and build visual identities that leave lasting impressions.",
  ],
  location: "Bangladesh",
  available: true,
  stats: [
    { number: 6, suffix: "+", label: "Years Experience" },
    { number: 20, suffix: "+", label: "Projects Done" },
    { number: 100, suffix: "%", label: "Pure Passion" },
    { number: 15, suffix: "+", label: "Happy Clients" },
  ],
  contact: {
    email: "md@sagarmiah.com",
    whatsapp: "Ahamed Sagar",
    whatsappLink: "https://wa.me/+19283943114",
    facebook: "Ahamed Sagar",
    facebookLink: "https://facebook.com/ahmedsagarsp",
    instagram: "Ahamed Sagar",
    instagramLink: "https://instagram.com/sag0r.sp",
    linkedin: "Sagar Miah",
    linkedinLink: "https://linkedin.com/in/Sagorsp",
  },
};

export const skills = [
  {
    icon: "📱",
    name: "Social Media Management",
    level: 92,
    color: "cyan",
    desc: "Facebook, Instagram, TikTok, YouTube — building brand presence, community engagement, and driving measurable growth across all major platforms.",
    tags: ["Facebook", "Instagram", "TikTok", "YouTube"],
  },
  {
    icon: "🎬",
    name: "Video Editing",
    level: 88,
    color: "purple",
    desc: "Cinematic edits, reels, Shorts, and brand videos. From raw footage to polished final content with motion graphics and storytelling.",
    tags: ["Premiere Pro", "After Effects", "CapCut"],
  },
  {
    icon: "📷",
    name: "Photo Editing & Retouching",
    level: 95,
    color: "pink",
    desc: "Professional retouching, color grading, and enhancement. Delivering gallery-quality images with precision and artistic flair.",
    tags: ["Photoshop", "Lightroom"],
  },
  {
    icon: "🎭",
    name: "Photography",
    level: 90,
    color: "cyan",
    desc: "Event coverage, product photography, portraits, and cinematic storytelling that captures emotions and creates lasting impressions.",
    tags: ["Events", "Portraits", "Products"],
  },
  {
    icon: "✏️",
    name: "Logo & Graphic Design",
    level: 87,
    color: "purple",
    desc: "Brand identity systems, logos, posters, and creative graphics that leave a memorable visual impression across all touchpoints.",
    tags: ["Illustrator", "Canva", "Figma"],
  },
  {
    icon: "✍️",
    name: "Copywriting & Content Creation",
    level: 84,
    color: "pink",
    desc: "Compelling captions, ad copy, campaign strategies, and content plans that convert audiences into loyal customers.",
    tags: ["Ad Copy", "Captions", "Strategy"],
  },
];

export const tools = [
  { icon: "🎨", name: "Photoshop" },
  { icon: "✒️", name: "Illustrator" },
  { icon: "🎬", name: "Premiere Pro" },
  { icon: "⭐", name: "After Effects" },
  { icon: "🖼️", name: "Canva" },
  { icon: "📐", name: "Figma" },
  { icon: "📷", name: "Lightroom" },
  { icon: "✂️", name: "CapCut" },
];

export const projects = [
  {
    id: 1,
    emoji: "🛍️",
    title: "Fashion Brand",
    desc: "Complete brand management including social media strategy, product showcases, and online campaigns that boosted sales and community engagement.",
    tags: ["Branding", "Social Media"],
    cats: ["branding", "social"],
    gradient: "from-cyan-500/10 to-purple-500/10",
  },
  {
    id: 2,
    emoji: "📸",
    title: "Event Photography Portfolio",
    desc: "Capturing memorable moments through creative photography and cinematic videography — events, portraits, and storytelling content designed to preserve emotions.",
    tags: ["Photography", "Events"],
    cats: ["photo"],
    gradient: "from-purple-500/10 to-pink-500/10",
  },
  {
    id: 3,
    emoji: "🎯",
    title: "Viral Content Campaigns",
    desc: "Strategic content for Facebook, Instagram, TikTok and YouTube — creative videos highlighting products, offers and customer stories to build trust and boost sales.",
    tags: ["Social Media", "TikTok"],
    cats: ["social", "video"],
    gradient: "from-pink-500/10 to-cyan-500/10",
  },
  {
    id: 4,
    emoji: "✏️",
    title: "Brand Identity Systems",
    desc: "Creating complete visual identity systems including logo design, color palettes, typography, and brand guidelines for growing businesses.",
    tags: ["Logo Design", "Branding"],
    cats: ["branding"],
    gradient: "from-cyan-500/8 to-purple-500/8",
  },
  {
    id: 5,
    emoji: "🎬",
    title: "Cinematic Video Projects",
    desc: "Cinematic storytelling through video — from event reels to brand films, crafting compelling narratives that capture attention and drive action.",
    tags: ["Video", "Cinematic"],
    cats: ["video", "photo"],
    gradient: "from-purple-500/8 to-pink-500/8",
  },
  {
    id: 6,
    emoji: "📊",
    title: "Social Growth Strategy",
    desc: "Developing and executing data-driven social media strategies that grew follower counts, increased engagement, and converted audiences into customers.",
    tags: ["Strategy", "Growth"],
    cats: ["social", "branding"],
    gradient: "from-cyan-500/8 to-pink-500/8",
  },
];

export const experience = [
  {
    period: "Feb 2026 — Present",
    company: "Rockline",
    role: "Co-Founder & Operations Manager",
    desc: "I oversee daily operations, team coordination, and customer service, ensuring Rockline delivers quality fashion and a great shopping experience for every customer.",
    tags: ["Team Management", "Operations", "Customer Service"],
    color: "cyan",
    current: true,
    duration: "Present",
  },
  {
  role: "Social Media Manager & Video Editor",
  company: "Cell X",
  period: "Jul 2026 — Present",
  duration: "Remote",
  description:
    "Managing Cell X’s social media presence through strategic content planning, engaging campaigns, and professional video editing. I create and optimize short-form video content, promotional reels, and social media creatives to strengthen brand visibility and audience engagement.",
  tags: [
    "Social Media Management",
    "Video Editing",
    "Content Strategy",
    "Reels",
    "Digital Marketing",
    "Brand Promotion"
  ],
  current: true,
  remote: true
},
{
  role: "Social Media Manager & Graphic Designer",
  company: "Mobile Arena",
  period: "Oct 2026 — Present",
  duration: "Remote",
  description:
    "Managing Mobile Arena’s social media content and visual communication while creating professional promotional graphics, campaign creatives, and branded social media designs. I focus on maintaining a consistent brand identity and producing engaging content that supports marketing and sales.",
  tags: [
    "Social Media Management",
    "Graphic Design",
    "Content Creation",
    "Branding",
    "Social Media Design",
    "Digital Marketing"
  ],
  current: true,
  remote: true
  },
  {
    period: "Jan 2025 — Feb 2026",
    company: "Gadget & Park",
    role: "Social Media Manager",
    desc: "I manage social media, marketing, and content creation to promote our brand and engage customers. I handle product showcases, online campaigns, and creative videos for Facebook, Instagram, TikTok, and YouTube. My work focuses on highlighting our latest products, offers, and customer experiences to build trust and boost sales.",
    tags: ["Social Media", "Content Strategy", "Video Production", "Digital Marketing"],
    color: "purple",
    current: false,
    duration: "1 yr 2 mos",
  },
  {
    period: "Nov 2023 — Apr 2024",
    company: "MY Outsourcing LTD",
    role: "Call Center Representative",
    desc: "Handling client inquiries, resolving customer issues, and providing support to ensure a smooth and satisfactory customer experience. Responsible for maintaining communication, managing service requests, and upholding company service standards.",
    tags: ["Client Relations", "Communication", "Customer Support"],
    color: "pink",
    current: false,
    duration: "6 mos",
  },
  {
    period: "Sep 2021 — Oct 2023",
    company: "Moments Keeper",
    role: "HR & Core Photographer",
    desc: "Focused on capturing, editing, and presenting memorable moments through creative photography and videography. Work included event coverage, cinematic edits, and storytelling content designed to preserve emotions and create lasting impressions.",
    tags: ["Photography", "Videography", "Event Coverage", "Photo Editing"],
    color: "cyan",
    current: false,
    duration: "2 yrs 2 mos",
  },
  {
    period: "Oct 2018 — Mar 2020",
    company: "Bikolpo Photostat & computer",
    role: "Computer Operator",
    desc: "Efficient and detail-oriented computer operator managing data entry, office software, and computer systems. Maintaining accurate records, supporting administrative tasks, and ensuring smooth digital operations.",
    tags: ["Data Entry", "MS Office", "Administration"],
    color: "muted",
    current: false,
    duration: "1 yr 6 mos",
  },
];

export const values = [
  { icon: "🎯", title: "Precision", color: "cyan", desc: "Every pixel, every frame, every caption is crafted with intention and attention to detail." },
  { icon: "✨", title: "Creativity", color: "purple", desc: "Pushing boundaries to deliver work that surprises, inspires, and makes a real impact." },
  { icon: "🤝", title: "Connection", color: "pink", desc: "Building authentic relationships between brands and their audiences through storytelling." },
];

export const filterCategories = [
  { id: "all", label: "All Work" },
  { id: "branding", label: "Branding" },
  { id: "photo", label: "Photography" },
  { id: "social", label: "Social Media" },
  { id: "video", label: "Video" },
];
